import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { FadeInAnimation } from '../shared/fade-in.animation';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
  animations: [FadeInAnimation]
})
export class ErrorDialogComponent implements OnInit {

  message: string

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.message = this.data.message
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/error-dialog.component.ts